export const AboutContent = () => {
  return (
    <div className="about-content-wrapper">
      <p className="about-content-wrapper__description page-title">O NAS</p>
      <img
        className="about-content-wrapper__image"
        src="assets/Slider/slider1.jpg"
        alt="flowers"
      />
      <p>PARĘ SŁÓW O FIRMIE</p>
    </div>
  );
};
